const handleApiError = (error) => {
    error.apiMessage = error.response?.data?.Message || 'Error de servidor';
    throw error; 
  };
  
  export default handleApiError;